import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "base-camera" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "actions" }

import { ref, onMounted, onBeforeMount, nextTick, computed } from "vue";
import { useI18n } from "vue-i18n";
import store from "@/store";


export default /*@__PURE__*/_defineComponent({
  __name: 'camera',
  emits: ["close", "capture"],
  setup(__props, { emit: __emit }) {

const { t } = useI18n();
const emit = __emit;

const video = ref<HTMLVideoElement | null>(null);
const canvas = ref<HTMLCanvasElement | null>(null);
const image = ref<string | null>(null);
const stream = ref<MediaStream | null>(null);
const loading = ref(false);

// Direção da câmera: 'user' (frontal) ou 'environment' (traseira)
const cameraFacingMode = ref<"user" | "environment">("environment");

const isMobile = computed(() => store.getters.mobile);

function imageCapture() {
  if (!canvas.value || !video.value) return;

  const context = canvas.value.getContext("2d");
  canvas.value.width = video.value.videoWidth;
  canvas.value.height = video.value.videoHeight;

  context?.drawImage(
    video.value,
    0,
    0,
    canvas.value.width,
    canvas.value.height
  );

  image.value = canvas.value.toDataURL("image/png");

  closeCamera();

  setTimeout(() => {
    emit("capture", image.value);
  }, 100);
}

async function initCamera() {
  if (!video.value || !canvas.value) return;

  try {
    loading.value = true;

    if (stream.value) {
      stream.value.getTracks().forEach((track) => track.stop());
    }

    stream.value = await navigator.mediaDevices.getUserMedia({
      video: {
        facingMode: cameraFacingMode.value,
      },
      audio: false,
    });

    video.value.srcObject = stream.value;
    loading.value = false;
  } catch (error) {
    console.error("Erro ao acessar a câmera:", error);
    loading.value = false;
  }
}

function switchCamera() {
  cameraFacingMode.value =
    cameraFacingMode.value === "user" ? "environment" : "user";
  initCamera();
}

function closeCamera() {
  if (stream.value) {
    stream.value.getTracks().forEach((track) => track.stop());
    stream.value = null;
  }

  // Só limpe as refs depois de parar o stream
  if (video.value) {
    video.value.srcObject = null;
  }
}

function cancel() {
  image.value = null;
  closeCamera();
  emit("close");
}

onBeforeMount(() => {
  closeCamera();
});

onMounted(async () => {
  await nextTick();
  initCamera();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("video", {
        ref_key: "video",
        ref: video,
        autoplay: "",
        playsinline: "",
        muted: "",
        style: _normalizeStyle({ opacity: image.value ? 0 : 1 })
      }, null, 4),
      _createElementVNode("div", _hoisted_3, [
        (isMobile.value)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "btn btn-md btn-secondary px-4",
              onClick: switchCamera
            }, _toDisplayString(_unref(t)("common.labels.switch_camera")), 1))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-md btn-primary px-4",
          onClick: imageCapture
        }, _toDisplayString(_unref(t)("common.labels.capture")), 1),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-md btn-default px-4",
          onClick: cancel
        }, _toDisplayString(_unref(t)("common.labels.cancel")), 1)
      ])
    ]),
    _createElementVNode("canvas", {
      ref_key: "canvas",
      ref: canvas,
      style: {"display":"none"}
    }, null, 512)
  ]))
}
}

})